export default __webpack_public_path__ + "static/media/annex1.697b3701.png";